import React, { useEffect, useState } from "react";
import Icon, { DownOutlined, FormOutlined } from "@ant-design/icons";
import { Dropdown, Form, Input, Menu, Space, Typography } from "antd";
import Table, { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import { ReactComponent as iconGroup } from "assets/groupIcon.svg";
import { ReactComponent as forumIcon } from "assets/forumIcon.svg";
import { DataCourse, statusTypes } from "types";
import "react-quill/dist/quill.snow.css";
import "./style.scss";
import {
	AddCourseModal,
	AddStudentInCourseModal,
	// AddStudentModal,
	EditCourseModal,
	ViemForumModal,
} from "components";
// import { dataCourse } from "utils/mocks";
import { useNavigate } from "react-router-dom";
import { api } from "services/api";

export const ManageCourses: React.FC = () => {
	const [selectedValue, setSelecteValue] = useState<string>("10");
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [isOpenEdit, setIsOpenEdit] = useState<boolean>(false);
	const [isOpenNewStudentModal, setIsOpenNewStudentModal] =
		useState<boolean>(false);
	const [isOpenForum, setIsOpenForum] = useState<boolean>(false);
	const [paginationInfo, setPaginationInfo] = useState<TablePaginationConfig>();
	const [totalItensValue, setTotalItensValue] = useState<number>(0);
	const [currentImgURL, setCurrentImgURL] = useState<string>("");
	const [courseStatus, setCourseStatus] = useState<boolean>(false);
	const [currentCourseData, setCurrentCourseData] = useState<DataCourse>();
	const [courses, setCourses] = useState<any[]>();
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const navigate = useNavigate();
	const [form] = Form.useForm();
	const [addStudentForm] = Form.useForm();

	const [editForm] = Form.useForm();

	const menu = (
		<Menu
			selectable
			// @ts-ignore
			onClick={(e) => setSelecteValue(e.key)}
			defaultSelectedKeys={["3"]}
			items={[
				{
					key: "10",
					label: "10",
				},
				{
					key: "20",
					label: "20",
				},
				{
					key: "30",
					label: "30",
				},
				{
					key: "40",
					label: "40",
				},
			]}
		/>
	);

	const getUpdatedInfo = async (id: string) => {
		setIsLoading(true);
		if (courses) {
			const {
				data: {
					data: { course },
				},
			} = await api.get(`/courses/${id}`);

			setIsLoading(false);

			setCurrentCourseData(course);
		}
	};

	const columns: ColumnsType<DataCourse> = [
		{
			title: "Nome",
			dataIndex: "title",
			key: "title",
			render: (text) => <p style={{ margin: 0 }}>{text}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/course/${data.id}`, {
							state: {
								data,
							},
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Cadastrado em",
			dataIndex: "created_at",
			key: "created_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/course/${data.id}`, {
							state: {
								data,
							},
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Última edição",
			dataIndex: "updated_at",
			key: "updated_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/course/${data.id}`, {
							state: {
								data,
							},
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (text) => <p style={{ margin: 0 }}>{statusTypes[text]}</p>,
			onCell: (data) => {
				return {
					onClick: (e) =>
						navigate(`${window.location.pathname}/course/${data.id}`, {
							state: {
								data,
							},
						}),
					style: { cursor: "pointer" },
				};
			},
		},
		{
			title: "Ativo",
			dataIndex: "is_active",
			key: "is_active",
			render: (active) => (
				<p style={{ margin: 0 }}>{active === true ? "Sim" : "Não"}</p>
			),
		},
		{
			title: "",
			key: "action",
			render: (_, record) => (
				<Space size="middle" style={{ cursor: "initial" }}>
					<FormOutlined
						className="edit"
						onClick={async () => {
							await getUpdatedInfo(`${record?.id}`);
							setIsOpenEdit(true);
						}}
					/>
					<Icon
						component={iconGroup}
						className="group"
						onClick={() => {
							setIsOpenNewStudentModal(true);
							setCurrentCourseData(record);
						}}
					/>
					<Icon
						component={forumIcon}
						style={{ fontSize: "28px" }}
						className="group"
						onClick={() => {
							setIsOpenForum(true);
							setCurrentCourseData(record);
						}}
					/>
				</Space>
			),
		},
	];

	useEffect(() => {
		setCourses(undefined);
		api
			.get(
				`/courses?per_page=${selectedValue}&paginate=true&page=${
					paginationInfo?.current ? paginationInfo.current : 1
				}`
			)
			.then((res) => {
				setTotalItensValue(Number(res?.data?.pagination?.total));
				setCourses(res.data.data.courses);
			});
	}, [paginationInfo, selectedValue]);

	return (
		<div className="m-courses">
			<AddCourseModal
				form={form}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				courseStatus={courseStatus}
				setCourseStatus={setCourseStatus}
				setCourses={setCourses}
			/>

			<AddStudentInCourseModal
				form={addStudentForm}
				isOpen={isOpenNewStudentModal}
				setIsOpen={setIsOpenNewStudentModal}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				courseStatus={courseStatus}
				setCourseStatus={setCourseStatus}
				currentCourseData={currentCourseData as DataCourse}
			/>

			<EditCourseModal
				form={editForm}
				isOpen={isOpenEdit}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				setIsOpen={setIsOpenEdit}
				setCourseStatus={setCourseStatus}
				setCourses={setCourses}
				currentCourseData={currentCourseData}
			/>

			<ViemForumModal
				setIsOpen={setIsOpenForum}
				isOpen={isOpenForum}
				currentCourseData={currentCourseData}
				isCourse={true}
			/>

			<div className="m-courses__container">
				<h1 className="m-courses__container__title">Cursos</h1>
				<div className="m-courses__container__input">
					<div className="m-courses__container__input__user-number">
						Exibir{" "}
						{
							<Dropdown overlay={menu}>
								<Typography.Text>
									{selectedValue}
									<DownOutlined style={{ marginLeft: "5px" }} />
								</Typography.Text>
							</Dropdown>
						}{" "}
						cursos
					</div>
					<Input placeholder="Pesquisar..." />
					<button
						className="m-courses__container__input__btn"
						onClick={() => setIsOpen(true)}
					>
						+ Adicionar Curso
					</button>
				</div>
				<Table
					loading={courses === undefined || isLoading}
					columns={columns}
					dataSource={courses}
					onChange={(e) => setPaginationInfo(e)}
					pagination={{
						total: totalItensValue,
						showSizeChanger: false,
						pageSize: +selectedValue,
					}}
				/>
			</div>
		</div>
	);
};
